import { gql } from "@apollo/client";
import client from "./graphql";

export const getMovies = (limit, Filters=null,moviesList, setmoviesList,filterQueries = [],mode = "set",start = null) => {
  let filterStrings = [];
  if (Filters && Filters.year !== "All")
    filterStrings.push(`movie_year : "${Filters.year}"`);
  if (Filters && Filters.language !== "All")
    filterStrings.push(`movie_language : "${Filters.language}"`);
  if (Filters && Filters.genre !== "All")
    filterStrings.push(`movie_genres_in : "${Filters.genre}"`);
  client
    .query({
      query: gql`
            query {
              moviesConnection(where :{${filterStrings.concat(filterQueries).join(",")}}){
                aggregate{
                  count
                }
              }
              movies(sort: "release_date:desc",limit: ${
                limit ? limit : 10
              },${start ? `start : ${start},` : ``}where :{${filterStrings.concat(filterQueries).join(",")}}){
                poster_path
                slug
                title
                movie_year {
                  year
                }
              }
            }
      `,
    })
    .then((result) => {
      mode === "set" && setmoviesList({...moviesList,movies : result.data.movies,count : result.data.moviesConnection.aggregate.count,start : limit,query : filterStrings.concat(filterQueries)});
      mode === "append" && setmoviesList(prevState => ({...prevState,movies : prevState.movies.concat(result.data.movies),start : prevState.start + prevState.limit,query : filterStrings.concat(filterQueries)}))
    })
    .catch((err) => console.log(err));
};
